
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		url: { type: String, required: true },
		hideCounterAtUrl: { type: Boolean, required: false, default: false },
	},
});
